import { createFileRoute, Outlet } from "@tanstack/react-router"

// this is for breadcrumbs

export const Route = createFileRoute("/app/contracts/contracts")({
  component: Outlet,
  beforeLoad: ({ context }) => ({
    getTitle: () => context.t && context.t("Contracts"),
  }),
})
